// extracted by mini-css-extract-plugin
export default {"container":"ManualEntry_container__3H495","button":"ManualEntry_button__7HzPl","infoSpan":"ManualEntry_infoSpan__b3CeF"};